import { initializeApp } from "firebase/app";
import { firebaseConfig } from "./firebase-config.js";

/** @type {import("firebase/app").FirebaseApp | null} */
var firebaseAppInstance = null;

/**
 * Shared Firebase app singleton for Analytics, RTDB, Auth, etc.
 * @returns {import("firebase/app").FirebaseApp | null}
 */
export function getFirebaseApp() {
  if (typeof window === "undefined") return null;
  if (firebaseAppInstance) return firebaseAppInstance;
  firebaseAppInstance = initializeApp(firebaseConfig);
  return firebaseAppInstance;
}

/** Test helper — reset singleton between tests. */
export function resetFirebaseAppForTests() {
  firebaseAppInstance = null;
}
